import { useFormContext } from 'react-hook-form';
import invariant from 'tiny-invariant';

import type { FormWithLines } from './FormLines';

export const useFormWithLinesContext = () => {
  const form = useFormContext<FormWithLines>();

  invariant(form, 'useFormWithLinesContext hook must be called inside <FormLines />');

  return form;
};
